import { render } from "./signup.vue?vue&type=template&id=0e3825b4&scoped=true"
import script from "./signup.vue?vue&type=script&lang=js"
export * from "./signup.vue?vue&type=script&lang=js"

import "./signup.vue?vue&type=style&index=0&id=0e3825b4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e3825b4"]])

export default __exports__